import React from 'react';
import PropTypes from 'prop-types';
import Head from 'next/head';
import GlobalCss from './GlobalCss';
import Footer from '../components/mobile/Footer';

const Layout = ({ children, shouldShowSocialMedia }) => (
  <div>
    <Head>
      <GlobalCss />
    </Head>
    {children}
    <Footer shouldShowSocialMedia={shouldShowSocialMedia} />
  </div>
);

Layout.defaultProps = {
  shouldShowSocialMedia: false,
};

Layout.propTypes = {
  shouldShowSocialMedia: PropTypes.bool,
  children: PropTypes.arrayOf(PropTypes.element).isRequired,
};

export default Layout;



// WEBPACK FOOTER //
// ./app/common/Layout.js